import { call, put, takeLatest } from 'redux-saga/effects';
import HeroPillAPI from 'api-services/HeroPillApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { ADD_D2D_PILL, EDIT_D2D_PILL, REMOVE_D2D_PILL } from './actionTypes';
import { addPillDone, addPillError, editPillDone, editPillError, removePillDone, removePillError } from './actionCreators';
import { logout } from '../auth/actionCreators';
// add
export function* addPill(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroPillAPI.addDayToDayPill, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(addPillDone(Object.assign(Object.assign({}, action.data), { slot: result.data.slot, isAutoApplied: result.data.auto_apply })));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(addPillError(result.msg));
    }
}
export function* watchAddPillCalls(constAccessParams) {
    yield takeLatest(ADD_D2D_PILL, addPill, constAccessParams);
}
// edit
export function* editPill(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroPillAPI.editDayToDayPill, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(editPillDone({ isAutoApplied: result.data.auto_apply }));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(editPillError(result.msg));
    }
}
export function* watchEditPillCalls(constAccessParams) {
    yield takeLatest(EDIT_D2D_PILL, editPill, constAccessParams);
}
// remove
export function* removePill(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroPillAPI.removeDayToDayPill, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(removePillDone({
            slot: action.data,
            isAutoApplied: result.data.auto_apply
        }));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(removePillError(result.msg));
    }
}
export function* watchRemovePillCalls(constAccessParams) {
    yield takeLatest(REMOVE_D2D_PILL, removePill, constAccessParams);
}
//# sourceMappingURL=saga.js.map